module.exports = __webpack_public_path__ + "static/media/art-by-lonfeldt-592708-unsplash.a70f31c4.jpg";